module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', [_vm._v("複製此分店" + _vm._s(_vm.titleType) + "廣告至其他店家")])]), _vm._v(" "), _c('p', {
    staticClass: "text-light-gray"
  }, [_vm._v("將特定店家尚有效的廣告全數複製到指定同步的店家，原店家的有效廣告會立即刪除")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-left"
  }, [_c('h5', [_vm._v("套用門市")]), _vm._v(" "), _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      key: ("storeClass-" + index),
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n          " + _vm._s(storeClass.name) + "\n        ")])])
  })], 2), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-left"
  }, [_vm._v("參與店家")]), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    attrs: {
      "to": '/adTable/' + _vm.$route.params.brand_id + '/' + _vm.$route.params.store_id
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.copyAd()
      }
    }
  }, [_vm._v("\n      確定\n    ")])], 1), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffbadfbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/CopyAdTemp.vue
// module id = 2570
// module chunks = 1